// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorMyCatalog = (client) => ({
    /**
     * `GET /vendor/my-catalog/retailers`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorMyCatalogRetailersList
     * @source apps/backend/src/api/vendor/my-catalog/retailers/route.ts
     */
    listRetailers: (query, headers) => client.fetch("/vendor/my-catalog/retailers", { method: "GET", query, headers }),
});
//# sourceMappingURL=my-catalog.js.map